// IMPORTANT: Make sure this is in sync with functions/src/index.ts
export enum STRIPE_PROMOTION_VALID_ITEM_TYPE {
    coupon = 'coupon',
    price = 'price',
}
